import { Injectable } from '@angular/core';  
import { BehaviorSubject } from 'rxjs';  

@Injectable({  
  providedIn: 'root'  
})  
export class StackService {  
  private stack: any[] = [];  
  private stackSource = new BehaviorSubject<any[]>(this.stack);  
  currentStack = this.stackSource.asObservable();  

  push(item: any) {  
    if (!this.stack.includes(item)) { // Check if the item is not already in the stack  
      this.stack.push(item);  
      this.stackSource.next(this.stack);  
    }
  }  

  pop(): any {  
    const item = this.stack.pop();  
    this.stackSource.next(this.stack);  
    return item;  
  }  

  // delete(serial: any): void {
  //   const index = this.stack.indexOf(serial);
  //   if (index !== -1) {
  //     this.stack.splice(index, 1);
  //     this.stackSource.next(this.stack); 
  //   }
  // }

  delete(serial: any): void {
    let deleted = false;
    
    // Use filter to create a new array without the matching serials
    this.stack = this.stack.filter(item => {
      if (item === serial) {
        deleted = true;
        return false;
      }
      return true;
    });
  
    // Only emit the updated stack if any item was deleted
    if (deleted) {
      this.stackSource.next(this.stack);
    }
  }

  getStack(): any[] {  
    return this.stack;  
  }  
}